var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "div",
            { staticClass: "promo-container" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("h1", { staticStyle: { "font-size": "2vh" } }, [
                      _vm._v(
                        "Ideal for real estate professionals, mortgage brokers, accountants, migration agents, and related businesses looking to present new property opportunities to their clients\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-divider",
                                { staticClass: "divider-wrapper" },
                                [_vm._v(" Already have an Account? ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "sign-in-btn",
                                  attrs: { type: "primary", size: "large" },
                                  on: { click: _vm.goToUConnect }
                                },
                                [
                                  _vm._v(
                                    "\n                  SIGN IN\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.alertDialogVisible
            ? _c("u-connect-check-user-dialog", {
                attrs: {
                  alertDialogVisible: _vm.alertDialogVisible,
                  dialogBoxTitle: _vm.dialogBoxTitle,
                  dialogBoxMessage: _vm.dialogBoxMessage,
                  userTypeErrorCode: _vm.userTypeErrorCode
                },
                on: { onClose: _vm.handleCloseRegisterDialog }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d69d67c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d69d67c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/uConnectDirectRegistration.vue
// module id = null
// module chunks = 